import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LifeEventsApi } from '../../../apis/LifeEventsApi/LifeEventsApi.ts';
import { LifeEvent } from '../LifeEvent.ts';

export function useDeleteLifeEventMutations() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [QueryKeys.lifeEvents, QueryKeys.lifeEvent],
        mutationFn: async ({ id }: { id: string }) => {
            return LifeEventsApi.deleteLifeEvent(id);
        },
        onSuccess: (_, { id, patientId }: { id: string; patientId: string }) => {
            const lifeEventsKey = [QueryKeys.lifeEvents, patientId];
            queryClient.setQueryData<LifeEvent[]>(
                lifeEventsKey,
                (prev) => prev?.filter((lifeEvent) => lifeEvent.id.toString() !== id) ?? [],
            );

            queryClient.invalidateQueries({ queryKey: [QueryKeys.lifeEvent] });
        },
    });
}
